<template>
    <modal :loading="loading" @close="close">
        <!-- HEADER -->
        <template #modal-header>
            <h3 class="mt-0 mb-3 clearfix">
                {{ $l10n.__('Paramétrage du filtre') }}
            </h3>
        </template>

        <!--  BODY - NEW FAVORITES -->
        <template #modal-body>
            <form class="flex-level flex-top" @keypress="favorite.errors.clearAll()">
                <div class="flex pr-3 border-right">
                    <h4 class="mt-0">
                        {{ $l10n.__('Informations du filtre') }}
                    </h4>

                    <div class="form-group">
                        <input
                            v-model="favorite.name"
                            type="text"
                            class="wp-10"
                            required
                            :class="{ 'ui-state-error': favorite.errors.has('name') }"
                            :readonly="!editable"
                        />
                        <span v-if="favorite.errors.has('name')" class="danger">{{
                            favorite.errors.get('name')
                        }}</span>
                    </div>

                    <small v-if="favoriteData != null" class="gray-60">
                        {{
                            $l10n.__('Créé par %(name)s, le %(date)s', {
                                name: favoriteData.owner,
                                date: favoriteData.created_at,
                            })
                        }}
                    </small>

                    <h5 class="mt-5 mb-3">{{ $l10n.__('Liste des filtres contenus') }} :</h5>

                    <div class="graylist fs-3 flex-level flex-column flex-top">
                        <span
                            v-for="(translation, index) in filterTranslations"
                            :key="index"
                            class="graylist-item pr-8 mb-3 regular"
                            v-html="translation"
                        >
                        </span>
                    </div>
                    <span v-if="favorite.errors.has('filters')" class="danger">{{
                        favorite.errors.get('filters')
                    }}</span>
                </div>
                <div class="flex pl-3 bl-1">
                    <h4 class="mt-0">{{ $l10n.__('Paramètres du filtre sauvegardé') }}</h4>

                    <h5 class="semibold mb-2">
                        {{ $l10n.__('Partage') }}
                    </h5>
                    <div class="flex-level mb-5">
                        <label>
                            {{ $l10n.__('Je souhaite partager ce filtre avec mes collaborateurs') }}
                        </label>
                        <div>
                            <div
                                class="form-toggle form-toggle-off flex-level"
                                :class="[favorite.shared ? 'form-toggle-on' : 'form-toggle-off']"
                                data-form-toggle="form-toggle"
                                @click.stop="favorite.shared = !favorite.shared"
                            >
                                <input id="shared-toggle" type="checkbox" :value="true" />
                                <div class="form-toggle-labels">
                                    <label data-form-toggle="on" for="shared-toggle">Partagé</label>
                                    <label data-form-toggle="off" for="shared-toggle"
                                        >Désactivé</label
                                    >
                                </div>
                                <div class="form-toggle-wrapper">
                                    <span class="form-toggle-handle"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="favoriteUrl">
                        <h5 class="semibold mb-2">
                            {{ $l10n.__('Lien de partage') }}
                        </h5>
                        <p>
                            {{
                                $l10n.__('Partagez ce filtre en communiquant l’adresse ci dessous')
                            }}
                        </p>
                        <div class="form-group clearfix">
                            <div class="form-input wp-10">
                                <p class="b-1 primary-50 aleft cpointer p-2 semibold br">
                                    {{ favoriteUrl }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="hasLayout">
                        <h5 class="semibold mb-2">
                            {{ $l10n.__('Affichage du tableau') }}
                        </h5>
                        <div class="flex-level mb-5">
                            <label>
                                {{
                                    $l10n.__(
                                        "Enregistrer l’ordre et l'affichage des colonnes. Ces préférences seront appliquées lors de la sélection de ce favori.",
                                    )
                                }}
                            </label>
                            <div>
                                <div
                                    class="form-toggle form-toggle-off flex-level"
                                    :class="[
                                        favorite.layout ? 'form-toggle-on' : 'form-toggle-off',
                                    ]"
                                    data-form-toggle="form-toggle"
                                    @click.stop="favorite.layout = !favorite.layout"
                                >
                                    <input id="layout-toggle" type="checkbox" :value="true" />
                                    <div class="form-toggle-labels">
                                        <label data-form-toggle="on" for="shared-toggle"
                                            >Activé</label
                                        >
                                        <label data-form-toggle="off" for="shared-toggle"
                                            >Désactivé</label
                                        >
                                    </div>
                                    <div class="form-toggle-wrapper">
                                        <span class="form-toggle-handle"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <!--  BODY - NEW FAVORITES -->

        <!-- MODAL FOOTER -->
        <template v-if="editable" #modal-footer>
            <div class="mt-5 flex flex-level flex-row flex-top">
                <div class="flex flex-column">
                    <!--<button @click.prevent="close" class="btn btn-no-background mb-2">
                        {{ $l10n.__('Modifier les filtres') }}
                    </button>-->
                </div>
                <div class="flex flex-level flex-right">
                    <CompassButton
                        :label="$t.__('common.actions.save')"
                        :disabled="isDisable"
                        @click.prevent="save"
                    />
                </div>
            </div>
        </template>
        <!-- MODAL FOOTER END -->
    </modal>
</template>

<script>
import _ from 'lodash';
import Modal from 'vcomponents/utilities/Modal.vue';
import Form from 'Core/commons/Form';

import { FilterTranslator } from './../filters/FilterTranslator';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('user');

export default {
    props: {
        listinghash: {
            type: String,
            required: true,
        },

        favoriteData: {
            type: Object,
            default() {
                return null;
            },
        },
        hasLayout: {
            type: Boolean,
            default() {
                return true;
            },
        },
    },

    data() {
        return {
            loading: false,
            favorite: new Form({
                id: '',
                name: '',
                shared: false,
                layout: false,
                columns: {},
                filters: {},
            }),
        };
    },

    mounted() {
        if (this.favoriteData == null) {
            this.favorite.fillData({
                columns: this.$store.getters[`${this.listinghash}/activeColumns`].map(
                    (col) => col.name,
                ),
                filters: this.activeFiltersData,
            });
        } else {
            this.favorite.fillData(this.favoriteData);
        }
    },

    computed: {
        ...mapState({
            userId: 'id',
        }),

        editable() {
            return (
                this.$store.state[this.listinghash].permissions.favorite &&
                ((this.favoriteData != null && this.userId == this.favoriteData.ownerid) ||
                    this.favorite.id == '')
            );
        },

        display() {
            return this.$store.state[this.listinghash].display;
        },

        listingname() {
            return this.$store.state[this.listinghash].listingname;
        },

        favoritesName() {
            return this.$store.state[this.listinghash].favoritesName;
        },
        filterTranslations() {
            const translations = [];

            for (const filterName in this.favorite.filters) {
                const filter = _.head(
                    this.$store.state[this.listinghash].filters.filter(
                        (filter) => filter.name == filterName,
                    ),
                );

                if (filter) {
                    filter.data = this.favorite.filters[filter.name];

                    const translator = new FilterTranslator(filter);
                    translations.push(translator.translate());
                }
            }

            return translations;
        },

        activeFiltersData() {
            const data = {};

            for (const filter of this.$store.getters[`${this.listinghash}/activeFilters`]) {
                data[filter.name] = filter.data;
            }

            return data;
        },

        favoriteUrl() {
            return this.$store.getters[`${this.listinghash}/favoriteSharedUrl`](this.favorite.id);
        },

        isDisable() {
            return this.favorite.name.length === 0;
        },
    },

    methods: {
        close() {
            this.$store.commit(`${this.listinghash}/hideDisplay`, 'favoritesForm');
            this.$store.commit(`${this.listinghash}/updateFavoriteData`, null);

            if (this.display.backToFavorites) {
                this.$store.commit(`${this.listinghash}/showDisplay`, 'favorites');
            }
        },

        save() {
            this.loading = true;
            this.favorite
                .setUseAxios()
                .post(`/favorites/${this.favoritesName}`)
                .then((response) => {
                    this.$store.commit(`${this.listinghash}/updateFavorite`, response.favorite);

                    if (this.favoriteData != null) {
                        Push.success(this.$l10n.__('Favori mis à jour!'), '');
                    } else {
                        Push.success(
                            this.$l10n.__('Favori "%(favorite)s" créé!', {
                                favorite: response.favorite.name,
                            }),
                            '',
                        );
                    }
                    this.close();
                })
                .catch((error) => (this.loading = false));
        },
    },

    components: {
        Modal,
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

// LIST SEPARATOR
.modal-body::after {
    display: block;
    content: ' ';
    width: 1px;
    height: 100%;
    background-color: $lightgrey;
    position: absolute;
    left: 50%;
    top: 0;
}

.favoriteFilters {
    height: calc(600px - 188px);
    overflow: scroll;
}
</style>
